import React, { Component, useState } from "react";
import { useContext } from "react";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { BsFillHeartFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import Slider from "react-slick";
import { RWebShare } from "react-web-share";
import { FaShareAlt } from "react-icons/fa";
import axios from "axios";
import { MySEO } from "./MySEO";
import Swal from "sweetalert2";

import {
  Accordion,
  Row,
  Col,
  Table,
  NavLink,
  Carousel,
  Badge,
  Nav,
  Button,
} from "react-bootstrap";
import { Link } from "react-router-dom";

import { ProductsList } from "./ProductsList";
import ProductCard from "./ProductCard";
import CartContext from "./CartContext";
import { LoadSpinner } from "./LoadSpinner";

export class HomeFooter extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      lat: "",
      longi: "",
      getlocation: false,
      signUpEmailId: "",
    };
  }
  latlong = (lat, longi) => {
    this.setState({ lat: lat });
    this.setState({ longi: longi });
  };
  GetMyLocation = () => {
    this.setState({ getlocation: true }, () => {
      this.setState({ getlocation: false });
    });
  };
  componentDidMount = () => {};

  onInputChange = (event) => {
    this.setState({ signUpEmailId: event.target.value });
  };

  validateEmail = (email) => {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  };
  OnClickSignUpGreenNewsletters = (e) => {
    if (this.validateEmail(this.state.signUpEmailId) == true) {
      axios
        .post(
          "https://gprogress.green.com.pg/ecommerce/newsletter_subscription/?newsletter_email=" +
            this.state.signUpEmailId
        )
        .then((response) => {
          if (response.status === 200) {
            // alert(response.data.Message);
            Swal.fire({
              title: "Information!",
              confirmButtonColor: "#23B14D",
              text: response.data.Message,
              confirmButtonText: "Ok",
            }).then((result) => {
              if (result.isConfirmed) {
              }
            });
            this.setState({ signUpEmailId: "" });
          } else {
            console.log("Failed");
          }
        })
        .catch((error) => {
          alert(error);
        });
    } else {
      Swal.fire({
        title: "Information!",
        confirmButtonColor: "#23B14D",
        text: "Invalid Email Id! Please try again.",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.isConfirmed) {
        }
      });
    }
  };
  render() {
    if (window.location.pathname == "/POS") return <></>;
    if (window.location.pathname == "/Kiosk") return <></>;

    if (this.context.homePageLoaded == false) return;
    if (new Date(this.context.store.storeEnd) > new Date() == false) {
      return <></>;
    }
    if (
      this.context.storeId == "" ||
      this.context.mainCategories.length == 0 ||
      this.context.subCategories.length == 0 ||
      this.context.prods.length == 0 ||
      this.context.theme == ""
    ) {
      return <></>;
    }

    return (
      <>
        {window.innerWidth > 1200 ? (
          <>
            {window.location.hostname == "green.elasticcart.com" ? (
              <>
                {/* GREEN Footer Design */}
                <div
                  style={{
                    backgroundColor:
                      this.context.theme.mainNavBarBackgroundColor,
                    color: this.context.theme.mainNavBarTextColor,
                  }}
                  className="border footerDsn02"
                >
                  <div class="container-fluid homefooter mt-0 py-5">
                    <div class="container pt-5">
                      <div class="row g-5">
                        <div class="col-lg-3 col-md-6">
                          <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                            Get In Touch
                          </h5>
                          <p class="mb-4"></p>
                          <div class="footerSliderAnimationDsn">
                            {this.context.selectedCountryCode == "PG" ? (
                              <>
                                <div
                                // class="footerSlider Slider01 active"
                                >
                                  <p class="mb-2 mx-1 address">
                                    <i class="bi bi-geo-alt   me-2"></i>
                                    <span className="">
                                      {this.context.storeSettings.storeName}
                                      ,&nbsp;
                                      {this.context.storeSettings.storeAddress}
                                    </span>
                                  </p>

                                  <p class="mb-2 mx-1 email">
                                    <i class="bi bi-envelope-open  me-2"></i>

                                    <span>
                                      <a
                                        href={`mailto:${this.context.storeSettings.storeEmailId}`}
                                      >
                                        {" "}
                                        {
                                          this.context.storeSettings
                                            .storeEmailId
                                        }
                                      </a>
                                    </span>
                                  </p>

                                  <p class="mb-0 mx-1">
                                    <i class="bi bi-telephone  me-2"></i>
                                    <a
                                      href={`tel:+${this.context.storeSettings.defaultCountryCode}-${this.context.storeSettings.storePhoneNo}`}
                                    >
                                      +
                                      {
                                        this.context.storeSettings
                                          .defaultCountryCode
                                      }
                                      -{this.context.storeSettings.storePhoneNo}
                                    </a>
                                  </p>
                                </div>
                              </>
                            ) : (
                              <>
                                <div
                                //  class="footerSlider Slider02"
                                >
                                  <p class="mb-2 mx-1 address">
                                    <i class="bi bi-geo-alt   me-2"></i>
                                    <span className="">
                                      GREEN Maestros EnerTech Private Limited,{" "}
                                      <br />
                                      115/15, Royal Roof Apartment, <br />
                                      Appusamy Road, Red Fields,
                                      <br />
                                      Coimbatore - 641045
                                      <br />
                                      Tamil Nadu, India
                                    </span>
                                  </p>

                                  <p class="mb-2 mx-1 email">
                                    <i class="bi bi-envelope-open  me-2"></i>

                                    <span>
                                      <a
                                        href={`mailto:${this.context.storeSettings.storeEmailId}`}
                                      >
                                        {" "}
                                        {
                                          this.context.storeSettings
                                            .storeEmailId
                                        }
                                      </a>
                                    </span>
                                  </p>

                                  <p class="mb-0 mx-1">
                                    <i class="bi bi-telephone  me-2"></i>
                                    <a
                                      href={`tel:+${this.context.storeSettings.defaultCountryCode}-${this.context.storeSettings.storePhoneNo}`}
                                    >
                                      +
                                      {
                                        this.context.storeSettings
                                          .defaultCountryCode
                                      }
                                      -{this.context.storeSettings.storePhoneNo}
                                    </a>
                                  </p>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                          <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                            Quick Links
                          </h5>
                          <div class="d-flex flex-column navFooter justify-content-start">
                            <a class=" mb-3 mx-1" href="/Home">
                              <i class="bi bi-arrow-right  me-2"></i>Home
                            </a>
                            {this.context.storeSettings.isQuotationSupported !=
                            true ? (
                              <>
                                <Link
                                  class=" mb-3 mx-4"
                                  to="/Cart"
                                  style={{
                                    color:
                                      this.context.theme.mainNavBarTextColor,
                                  }}
                                >
                                  <i class="bi bi-arrow-right  me-2"></i>My Cart
                                </Link>
                              </>
                            ) : (
                              <></>
                            )}
                            {this.context.userData.loginStatus == "active" &&
                            this.context.storeSettings.isQuotationSupported !=
                              true ? (
                              <>
                                <Link class="mb-3 mx-1" to="/Checkout">
                                  <i class="bi bi-arrow-right  me-2"></i>
                                  Checkout
                                </Link>
                              </>
                            ) : (
                              <>
                                <a class="mb-3 mx-1" to="/Checkout" disabled>
                                  <i class="bi bi-arrow-right  me-2"></i>
                                  Checkout
                                </a>
                              </>
                            )}
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                          <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                            Popular Links
                          </h5>
                          <div class="d-flex flex-column navFooter justify-content-start">
                            <Nav.Link
                              as={Link}
                              to="/TermsAndConditions"
                              className=""
                            >
                              <i class="bi bi-arrow-right  me-2"></i>
                              Terms & Conditions
                            </Nav.Link>
                            <Nav.Link
                              as={Link}
                              to="/PrivacyPolicy"
                              className=""
                            >
                              <i class="bi bi-arrow-right  me-2"></i>
                              Privacy Policy
                            </Nav.Link>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                          <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                            Newsletter
                          </h5>
                          <form action="" className="newsLetter">
                            <div class="input-group">
                              <input
                                type="text"
                                class="form-control p-3 text-white"
                                placeholder="Your Email"
                                name="signUpEmailId"
                                value={this.state.signUpEmailId}
                                onChange={(e) => this.onInputChange(e)}
                              />
                              <Button
                                className="btn-green-2 d-inline-block text-white"
                                onClick={(e) =>
                                  this.OnClickSignUpGreenNewsletters(e)
                                }
                              >
                                Sign Up
                              </Button>
                            </div>
                          </form>
                          {/* <h6 class="text-uppercase mt-4 mb-3">Follow Us</h6> */}
                          <div class="d-flex smIconFooter">
                            <a
                              href={this.context.storeSettings.linkedinUrl}
                              target="_blank"
                              className="me-2"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="29"
                                height="28"
                                viewBox="0 0 29 28"
                                fill="none"
                              >
                                <path
                                  d="M23.2985 2.24219H5.37818C3.83255 2.24219 2.57812 3.49659 2.57812 5.04219V22.9622C2.57812 24.5078 3.83255 25.7622 5.37818 25.7622H23.2985C24.8442 25.7622 26.0986 24.5078 26.0986 22.9622V5.04219C26.0986 3.49659 24.8442 2.24219 23.2985 2.24219ZM9.85827 11.2022V21.8422H6.4982V11.2022H9.85827ZM6.4982 8.10539C6.4982 7.32139 7.17021 6.72219 8.17823 6.72219C9.18625 6.72219 9.81907 7.32139 9.85827 8.10539C9.85827 8.88939 9.23105 9.52219 8.17823 9.52219C7.17021 9.52219 6.4982 8.88939 6.4982 8.10539ZM22.1785 21.8422H18.8184C18.8184 21.8422 18.8184 16.6566 18.8184 16.2422C18.8184 15.1222 18.2584 14.0022 16.8584 13.9798H16.8136C15.4584 13.9798 14.8984 15.1334 14.8984 16.2422C14.8984 16.7518 14.8984 21.8422 14.8984 21.8422H11.5383V11.2022H14.8984V12.6358C14.8984 12.6358 15.9792 11.2022 18.152 11.2022C20.3753 11.2022 22.1785 12.731 22.1785 15.8278V21.8422Z"
                                  fill="white"
                                  fill-opacity="0.6"
                                ></path>
                              </svg>
                            </a>
                            <a
                              href={this.context.storeSettings.facebookUrl}
                              target="_blank"
                              className="me-2"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                              >
                                <path
                                  d="M22.9626 2.24219H5.04224C3.49661 2.24219 2.24219 3.49659 2.24219 5.04219V22.9622C2.24219 24.5078 3.49661 25.7622 5.04224 25.7622H22.9626C24.5082 25.7622 25.7626 24.5078 25.7626 22.9622V5.04219C25.7626 3.49659 24.5082 2.24219 22.9626 2.24219ZM20.7225 10.6422H19.6025C18.4041 10.6422 17.9225 10.9222 17.9225 11.7622V13.4422H20.7225L20.1625 16.2422H17.9225V24.6422H15.1224V16.2422H12.8824V13.4422H15.1224V11.7622C15.1224 9.52219 16.2425 7.84219 18.4825 7.84219C20.1065 7.84219 20.7225 8.40219 20.7225 8.40219V10.6422Z"
                                  fill="white"
                                  fill-opacity="0.6"
                                ></path>
                              </svg>
                            </a>
                            <a
                              href={this.context.storeSettings.twitterUrl}
                              target="_blank"
                              className="me-2"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                              >
                                <path
                                  d="M22.9642 2.24219H5.04389C3.49826 2.24219 2.24384 3.49659 2.24384 5.04219V22.9622C2.24384 24.5078 3.49826 25.7622 5.04389 25.7622H22.9642C24.5099 25.7622 25.7643 24.5078 25.7643 22.9622V5.04219C25.7643 3.49659 24.5099 2.24219 22.9642 2.24219Z"
                                  fill="white"
                                  fill-opacity="0.5"
                                ></path>
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M6.04815 6.0632C6.07265 6.09797 6.21455 6.30255 6.36346 6.51784C6.63881 6.91593 7.86335 8.6857 9.03817 10.3835C9.39516 10.8994 10.0383 11.8288 10.4673 12.4488C10.8963 13.0688 11.45 13.8687 11.6976 14.2263C11.9453 14.584 12.1498 14.8811 12.1521 14.8866C12.1572 14.8992 12.1716 14.8819 11.8215 15.2855C11.3874 15.7858 11.2375 15.9587 11.0094 16.2222C10.8169 16.4445 10.6702 16.6138 10.3769 16.9521C10.3089 17.0306 10.1722 17.1884 10.0732 17.3028C9.97418 17.4171 9.84854 17.5621 9.794 17.6249C9.73945 17.6877 9.61384 17.8326 9.51485 17.947C9.28893 18.208 9.01877 18.52 8.85797 18.7054C8.78991 18.7839 8.6532 18.9417 8.55417 19.0561C8.45514 19.1704 8.31835 19.3282 8.2502 19.4067C8.18203 19.4852 8.03256 19.6577 7.91803 19.79C7.8035 19.9223 7.61291 20.1425 7.49449 20.2793C7.37607 20.4161 7.20602 20.6124 7.1166 20.7156C7.02717 20.8188 6.8634 21.0077 6.75266 21.1356C6.64192 21.2634 6.48296 21.4469 6.39942 21.5433C6.31587 21.6398 6.20156 21.7719 6.14536 21.8369C6.08917 21.9019 6.03385 21.9652 6.02242 21.9776L6.00165 22L6.69905 21.9995L7.39645 21.9991L7.77414 21.5619C7.98188 21.3215 8.33661 20.9116 8.56245 20.6511C9.01993 20.1233 9.46624 19.6082 9.78119 19.2443C10.1724 18.7925 10.3925 18.5384 10.4919 18.4241C10.5465 18.3613 10.6832 18.2035 10.7957 18.0734C10.9082 17.9433 11.056 17.7727 11.1241 17.6942C11.1922 17.6157 11.3289 17.4579 11.4279 17.3435C11.527 17.2292 11.6637 17.0714 11.7318 16.9929C11.7998 16.9144 11.9461 16.7456 12.0569 16.6177C12.1676 16.4899 12.3313 16.3009 12.4208 16.1978C12.5102 16.0946 12.6245 15.9618 12.6748 15.9027C12.7251 15.8436 12.77 15.795 12.7745 15.7948C12.779 15.7945 12.9864 16.0888 13.2353 16.4486C13.4842 16.8085 14.1919 17.8314 14.808 18.7217C15.4241 19.612 16.1865 20.7139 16.5023 21.1702L17.0764 22H19.4224C21.0154 22 21.7701 21.9973 21.7737 21.9916C21.7765 21.987 21.7752 21.9843 21.7707 21.9855C21.762 21.9879 21.7267 21.9374 20.746 20.5199C20.3891 20.0041 19.5436 18.7821 18.867 17.8043C18.1904 16.8265 17.4667 15.7806 17.2588 15.4801C17.0509 15.1796 16.5467 14.4512 16.1384 13.8614C15.7301 13.2716 15.3944 12.7851 15.3926 12.7804C15.3895 12.7728 15.5065 12.6358 16.1375 11.9076C16.2305 11.8003 16.4003 11.6043 16.5148 11.472C16.6293 11.3397 16.7915 11.1525 16.8751 11.0561C17.1889 10.6942 17.2799 10.5893 17.476 10.3629C17.5867 10.2351 17.7472 10.0497 17.8328 9.95096C17.9184 9.85223 18.0868 9.65774 18.2071 9.51875C18.4784 9.20534 18.7945 8.84041 19.0264 8.57288C19.1236 8.46075 19.2714 8.29011 19.3549 8.19368C19.5162 8.00736 19.7977 7.6825 20.065 7.37411C20.1544 7.27095 20.3149 7.08563 20.4217 6.96228C20.5284 6.83894 20.7414 6.59304 20.895 6.41584C21.0485 6.23863 21.1921 6.07257 21.2141 6.04683L21.2541 6H20.5599H19.8656L19.7402 6.14475C19.6712 6.22437 19.5589 6.35372 19.4908 6.43221C19.4226 6.5107 18.9775 7.02446 18.5015 7.5739C18.0256 8.12334 17.5583 8.66279 17.463 8.77268C17.1979 9.07847 17.0541 9.24441 16.8308 9.50255C16.7182 9.63262 16.5814 9.79042 16.5269 9.85321C16.4723 9.916 16.3356 10.0738 16.223 10.2039C16.1105 10.3339 15.9627 10.5046 15.8946 10.5831C15.8265 10.6616 15.6802 10.8304 15.5695 10.9582C15.4588 11.086 15.2982 11.2714 15.2127 11.3701C15.1271 11.4688 14.9927 11.624 14.9141 11.7149C14.8354 11.8058 14.7683 11.8773 14.7648 11.8738C14.7614 11.8703 14.5124 11.5115 14.2115 11.0765C13.9105 10.6414 13.6236 10.2267 13.5739 10.1549C13.5241 10.0832 13.2759 9.72449 13.0222 9.35787C12.7686 8.99124 12.142 8.08573 11.6299 7.34564L10.6987 6H8.35116H6.00359L6.04815 6.0632ZM7.90159 7.04176C7.90169 7.04515 7.93422 7.09378 7.97389 7.14985C8.01355 7.20591 8.20999 7.48481 8.41041 7.76962C8.74711 8.24809 9.31299 9.05187 10.262 10.3996C10.4704 10.6956 10.774 11.1268 10.9366 11.3578C11.0992 11.5888 11.4312 12.0603 11.6743 12.4057C12.5355 13.6289 13.2054 14.5805 13.8214 15.4557C13.9193 15.5947 14.3004 16.136 14.6684 16.6585C15.0363 17.181 15.4459 17.7627 15.5785 17.9511C15.711 18.1394 16.0727 18.6532 16.3822 19.0928C16.6916 19.5323 17.1049 20.1195 17.3006 20.3976C17.4963 20.6756 17.6729 20.9261 17.693 20.9541L17.7296 21.0051H18.7975H19.8654L19.8291 20.9541C19.8091 20.9261 19.6082 20.6408 19.3826 20.3201C19.157 19.9994 18.736 19.4012 18.447 18.9908C18.158 18.5804 17.7885 18.0557 17.6259 17.8247C17.1958 17.2138 16.6613 16.4544 16.3228 15.9735C16.1602 15.7425 15.8037 15.2361 15.5305 14.8481C14.6545 13.6042 14.2248 12.9939 13.9515 12.6055C13.6395 12.1622 13.0156 11.2759 12.4789 10.5138C12.0532 9.90919 11.4596 9.0659 10.7108 8.00204C10.433 7.60734 10.1665 7.22936 10.1186 7.16208L10.0314 7.03976L8.96641 7.03768C8.38066 7.03655 7.90149 7.03839 7.90159 7.04176Z"
                                  fill="black"
                                ></path>
                              </svg>
                            </a>
                            <a
                              href={this.context.storeSettings.instagramUrl}
                              target="_blank"
                              className="me-2"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="29"
                                height="28"
                                viewBox="0 0 29 28"
                                fill="none"
                              >
                                <path
                                  d="M8.9319 2.24219C5.32412 2.24219 2.39844 5.16781 2.39844 8.77552V19.2289C2.39844 22.8366 5.32412 25.7622 8.9319 25.7622H19.3854C22.9932 25.7622 25.9189 22.8366 25.9189 19.2289V8.77552C25.9189 5.16781 22.9932 2.24219 19.3854 2.24219H8.9319ZM21.9988 4.85552C22.7201 4.85552 23.3055 5.44091 23.3055 6.16219C23.3055 6.88347 22.7201 7.46885 21.9988 7.46885C21.2775 7.46885 20.6921 6.88347 20.6921 6.16219C20.6921 5.44091 21.2775 4.85552 21.9988 4.85552ZM14.1587 7.46885C17.7664 7.46885 20.6921 10.3945 20.6921 14.0022C20.6921 17.6099 17.7664 20.5355 14.1587 20.5355C10.5509 20.5355 7.62521 17.6099 7.62521 14.0022C7.62521 10.3945 10.5509 7.46885 14.1587 7.46885ZM14.1587 10.0822C13.119 10.0822 12.1219 10.4952 11.3868 11.2303C10.6516 11.9655 10.2386 12.9625 10.2386 14.0022C10.2386 15.0418 10.6516 16.0389 11.3868 16.774C12.1219 17.5092 13.119 17.9222 14.1587 17.9222C15.1983 17.9222 16.1954 17.5092 16.9306 16.774C17.6657 16.0389 18.0787 15.0418 18.0787 14.0022C18.0787 12.9625 17.6657 11.9655 16.9306 11.2303C16.1954 10.4952 15.1983 10.0822 14.1587 10.0822Z"
                                  fill="white"
                                  fill-opacity="0.6"
                                ></path>
                              </svg>
                            </a>
                            <a
                              href="https://www.youtube.com/@greenlimited4405"
                              target="_blank"
                              className="me-2"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="29"
                                height="28"
                                viewBox="0 0 29 28"
                                fill="none"
                              >
                                <path
                                  d="M25.028 8.03253C24.8106 6.83245 23.7746 5.95849 22.5723 5.68565C20.7732 5.30409 17.4436 5.03125 13.8412 5.03125C10.2408 5.03125 6.85792 5.30409 5.05669 5.68565C3.85658 5.95849 2.81847 6.77702 2.60105 8.03253C2.38149 9.39675 2.16406 11.3067 2.16406 13.7623C2.16406 16.2178 2.38149 18.1278 2.65434 19.492C2.8739 20.6921 3.90987 21.566 5.10998 21.8389C7.01993 22.2204 10.2941 22.4933 13.8966 22.4933C17.499 22.4933 20.7732 22.2204 22.6832 21.8389C23.8833 21.566 24.9193 20.7475 25.1388 19.492C25.3562 18.1278 25.6291 16.1624 25.6845 13.7623C25.5737 11.3067 25.3008 9.39675 25.028 8.03253ZM10.8952 17.5821V9.94244L17.5523 13.7623L10.8952 17.5821Z"
                                  fill="white"
                                  fill-opacity="0.6"
                                ></path>
                              </svg>
                            </a>
                            <a
                              href="https://vimeo.com/user154755399"
                              target="_blank"
                              className="me-2"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="27"
                                height="28"
                                viewBox="0 0 27 28"
                                fill="none"
                              >
                                <path
                                  d="M22.9648 2.24219H5.04444C3.49881 2.24219 2.24438 3.49659 2.24438 5.04219V22.9622C2.24438 24.5078 3.49881 25.7622 5.04444 25.7622H22.9648C24.5104 25.7622 25.7648 24.5078 25.7648 22.9622V5.04219C25.7648 3.49659 24.5104 2.24219 22.9648 2.24219Z"
                                  fill="white"
                                  fill-opacity="0.5"
                                ></path>
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M17.9208 8.06104C17.2265 8.20351 16.6871 8.48852 16.2026 8.96894C15.846 9.32251 15.6182 9.64446 15.3573 10.1635C15.1824 10.5116 14.9034 11.2125 14.9294 11.2385C14.9362 11.2453 15.0591 11.2112 15.2024 11.1626C15.5256 11.053 16.0538 11.013 16.2984 11.0794C16.5245 11.1409 16.739 11.3164 16.8174 11.5041C16.8934 11.6859 16.8932 12.2584 16.817 12.5406C16.7261 12.8772 16.5439 13.2809 16.2574 13.7804C15.5866 14.9497 14.9869 15.6509 14.6576 15.6509C14.4829 15.6509 14.3415 15.5161 14.1689 15.1851C13.8451 14.5643 13.6305 13.6855 13.2469 11.4096C12.9706 9.77061 12.9237 9.56833 12.7221 9.14612C12.5198 8.72247 12.2792 8.46334 11.9272 8.29007C11.6677 8.16227 11.5974 8.14709 11.2661 8.14722C10.9282 8.14731 10.8655 8.16162 10.5562 8.30917C10.1451 8.50536 9.71292 8.79977 9.21536 9.2225C8.49778 9.8322 7.0022 11.1828 7.0022 11.2212C7.0022 11.3103 7.62464 12.0445 7.68172 12.0226C7.71456 12.01 7.88343 11.9041 8.05695 11.7872C8.46872 11.5098 8.62541 11.4314 8.76753 11.4314C9.01091 11.4314 9.28692 11.6998 9.52356 12.1665C9.75242 12.6178 9.94917 13.2473 10.5463 15.4383C10.8943 16.7156 11.2304 17.8879 11.2931 18.0434C11.6301 18.8794 12.1567 19.5957 12.6194 19.8475C12.9188 20.0105 13.4053 20.0466 13.8317 19.9375C14.9369 19.6549 16.286 18.5451 17.774 16.6949C19.383 14.6941 20.4697 12.8233 20.8008 11.4845C20.9311 10.9577 20.9307 9.99616 20.8001 9.51065C20.5794 8.69054 20.1631 8.25506 19.4131 8.05974C19.1052 7.97952 18.3146 7.98022 17.9208 8.06104Z"
                                  fill="black"
                                ></path>
                              </svg>
                            </a>
                          </div>
                          <p class="copy-footer footer-end-media">
                            © {new Date().getFullYear()} GREEN. All Rights
                            Reserved.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="text-black text-center">
                <h5>
                  <b>
                    Powered by www.elasticcart.com, Bangalore, India 560100.
                    Contact: +919663617620, +919880582728
                  </b>
                </h5>
              </div> */}
                </div>
              </>
            ) : (
              <>
                <div
                  // style={{
                  //   backgroundColor:
                  //     window.location.hostname == "maicabagfactory.com"
                  //       ? "darkblue"
                  //       : this.context.theme.mainNavBarBackgroundColor,
                  //   color:
                  //     window.location.hostname == "maicabagfactory.com"
                  //       ? "white"
                  //       : this.context.theme.mainNavBarTextColor,
                  // }}
                  className="border=-0"
                >
                  <div className="p-5">
                    <h1>
                      <b>Our Location Map</b>
                    </h1>
                    <iframe
                      className="border"
                      src={this.context.storeSettings.googlemapEmbedUrl}
                      width="100%"
                      height="450"
                      style={{ border: "1" }}
                      allowfullscreen=""
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>

                  <div
                    class="container-fluid homefooter mt-0 py-5"
                    style={{
                      backgroundColor:
                        window.location.hostname == "maicabagfactory.com" ||
                        window.location.hostname == "www.maicabagfactory.com"
                          ? "#00ff00"
                          : this.context.theme.mainNavBarBackgroundColor,
                      color: this.context.theme.mainNavBarTextColor,
                    }}
                  >
                    <div class="container pt-5">
                      <div class="row g-5">
                        <div class="col-lg-4 col-md-6">
                          <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                            Get In Touch
                          </h5>
                          <p class="mb-4"></p>
                          <p class="mb-2 mx-3">
                            <i class="bi bi-geo-alt   me-2"></i>
                            <span className="">
                              {this.context.storeSettings.storeName},&nbsp;
                              {this.context.storeSettings.storeAddress}
                            </span>
                          </p>

                          <p class="mb-2 mx-3">
                            <i class="bi bi-envelope-open  me-2"></i>

                            <a
                              href={`mailto:${this.context.storeSettings.storeEmailId}`}
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                            >
                              <u>{this.context.storeSettings.storeEmailId}</u>
                            </a>
                          </p>

                          <p class="mb-0 mx-3">
                            <i class="bi bi-telephone  me-2"></i>
                            <a
                              href={`tel:+${this.context.storeSettings.defaultCountryCode}-${this.context.storeSettings.storePhoneNo}`}
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                            >
                              +{this.context.storeSettings.defaultCountryCode}-
                              {this.context.storeSettings.storePhoneNo}
                            </a>
                          </p>
                        </div>
                        <div class="col-lg-2 col-md-6">
                          <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                            Quick Links
                          </h5>
                          <div class="d-flex flex-column justify-content-start">
                            <a
                              class=" mb-3 mx-4 "
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                              href="/Home"
                            >
                              <i class="bi bi-arrow-right  me-2"></i>Home
                            </a>
                            {this.context.userData.loginStatus == "active" &&
                            this.context.storeSettings.isQuotationSupported !=
                              true ? (
                              <>
                                <Link
                                  class="mb-3 mx-4"
                                  to="/Checkout"
                                  style={{
                                    color:
                                      this.context.theme.mainNavBarTextColor,
                                  }}
                                >
                                  <i class="bi bi-arrow-right  me-2"></i>
                                  Checkout
                                </Link>
                              </>
                            ) : (
                              <></>
                            )}

                            {window.location.hostname ==
                            "green.elasticcart.com" ? (
                              <></>
                            ) : (
                              <>
                                <Link
                                  class=" mb-3 mx-4"
                                  to="/VisitorsCount"
                                  style={{
                                    color:
                                      this.context.theme.mainNavBarTextColor,
                                  }}
                                >
                                  <i class="bi bi-arrow-right  me-2"></i>{" "}
                                  Visitors Count
                                </Link>
                              </>
                            )}
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                          <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                            Popular Links
                          </h5>
                          <div class="d-flex flex-column justify-content-start">
                            <Nav.Link
                              as={Link}
                              to="/TermsAndConditions"
                              className=""
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                            >
                              <i class="bi bi-arrow-right  me-2"></i>
                              <u>Terms & Conditions</u>
                            </Nav.Link>
                            <Nav.Link
                              as={Link}
                              to="/PrivacyPolicy"
                              className=""
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                            >
                              <i class="bi bi-arrow-right  me-2"></i>
                              <u>Privacy Policy</u>
                            </Nav.Link>

                            <Nav.Link
                              as={Link}
                              to="/ContactUs"
                              className=""
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                            >
                              <i class="bi bi-arrow-right  me-2"></i>
                              <u>Contact Us</u>
                            </Nav.Link>

                            <Nav.Link
                              as={Link}
                              to="/Faqs"
                              className=""
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                            >
                              <i class="bi bi-arrow-right  me-2"></i>
                              <u>FAQs</u>
                            </Nav.Link>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                          <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                            Newsletter
                          </h5>
                          <form action="">
                            <div class="input-group">
                              <input
                                type="email"
                                class="form-control p-3"
                                placeholder="Your Email"
                                name="signUpEmailId"
                                value={this.state.signUpEmailId}
                                onChange={(e) => this.onInputChange(e)}
                              />
                              <button
                                class="btn btn-primary "
                                // onClick={(e) =>
                                //   this.OnClickSignUpGreenNewsletters(e)
                                // }
                              >
                                Sign Up
                              </button>
                            </div>
                          </form>
                          <h6 class="text-uppercase mt-4 mb-3">Follow Us</h6>
                          <div class="d-flex">
                            <a
                              class="btn btn-outline-primary btn-square me-2"
                              href={this.context.storeSettings.twitterUrl}
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                              target="_blank"
                            >
                              <i class="bi bi-twitter"></i>
                            </a>
                            <a
                              class="btn btn-outline-primary btn-square me-2"
                              href={this.context.storeSettings.facebookUrl}
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                              target="_blank"
                            >
                              <i class="bi bi-facebook"></i>
                            </a>
                            <a
                              class="btn btn-outline-primary btn-square me-2"
                              href={this.context.storeSettings.linkedinUrl}
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                              target="_blank"
                            >
                              <i class="bi bi-linkedin"></i>
                            </a>
                            <a
                              class="btn btn-outline-primary btn-square"
                              href={this.context.storeSettings.instagramUrl}
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                              target="_blank"
                            >
                              <i class="bi bi-instagram"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="text-center py-2"
                    style={{
                      backgroundColor:
                        window.location.hostname == "maicabagfactory.com" ||
                        window.location.hostname == "www.maicabagfactory.com"
                          ? "#00ff00"
                          : this.context.theme.mainNavBarBackgroundColor,
                      color: this.context.theme.mainNavBarTextColor,
                    }}
                  >
                    <div classname="container-fluid mx-0 px-0 ">
                      <div>
                        <h5>
                          <b>
                            Copyright © {this.context.storeSettings.storeName},
                            All Rights Reserved.
                          </b>
                        </h5>
                      </div>
                    </div>
                  </div>
                  {/* <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <div className="text-black text-center">
                    <div classname="container-fluid mx-0 px-0 bg-dark text-white">
                      <div class="bar">
                        <span class="">
                          Powered by{" "}
                          <a href="https://ElasticCart.com" target="_blank">
                            {" "}
                            www.ElasticCart.Com
                          </a>
                          , Bangalore, India 560100. Contact: +919663 617620,
                          +919880 582728
                        </span>
                      </div>
                    </div>
                  </div> */}
                </div>
              </>
            )}
          </>
        ) : (
          <>
            {this.context.portalMode == "CustomerPortal" ? (
              <>
                {window.location.hostname == "green.elasticcart.com" ? (
                  <>
                    {/* GREEN Footer Design */}
                    <div
                      style={{
                        backgroundColor:
                          this.context.theme.mainNavBarBackgroundColor,
                        color: this.context.theme.mainNavBarTextColor,
                      }}
                      className="border footerDsn02"
                    >
                      <div class="container-fluid homefooter mt-0 py-5">
                        <div class="container pt-5">
                          <div class="row g-5">
                            <div class="col-lg-3 col-md-6">
                              <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                                Get In Touch
                              </h5>
                              <p class="mb-4"></p>
                              <div class="footerSliderAnimationDsn">
                                {this.context.selectedCountryCode == "PG" ? (
                                  <>
                                    <div
                                    // class="footerSlider Slider01 active"
                                    >
                                      <p class="mb-2 mx-1 address">
                                        <i class="bi bi-geo-alt   me-2"></i>
                                        <span className="">
                                          {this.context.storeSettings.storeName}
                                          ,&nbsp;
                                          {
                                            this.context.storeSettings
                                              .storeAddress
                                          }
                                        </span>
                                      </p>

                                      <p class="mb-2 mx-1 email">
                                        <i class="bi bi-envelope-open  me-2"></i>

                                        <span>
                                          <a
                                            href={`mailto:${this.context.storeSettings.storeEmailId}`}
                                          >
                                            {" "}
                                            {
                                              this.context.storeSettings
                                                .storeEmailId
                                            }
                                          </a>
                                        </span>
                                      </p>

                                      <p class="mb-0 mx-1">
                                        <i class="bi bi-telephone  me-2"></i>
                                        <a
                                          href={`tel:+${this.context.storeSettings.defaultCountryCode}-${this.context.storeSettings.storePhoneNo}`}
                                        >
                                          +
                                          {
                                            this.context.storeSettings
                                              .defaultCountryCode
                                          }
                                          -
                                          {
                                            this.context.storeSettings
                                              .storePhoneNo
                                          }
                                        </a>
                                      </p>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div
                                    // class="footerSlider Slider02"
                                    >
                                      <p class="mb-2 mx-1 address">
                                        <i class="bi bi-geo-alt   me-2"></i>
                                        <span className="">
                                          GREEN Maestros EnerTech Private
                                          Limited, <br />
                                          115/15, Royal Roof Apartment, <br />
                                          Appusamy Road, Red Fields,
                                          <br />
                                          Coimbatore - 641045
                                          <br />
                                          Tamil Nadu, India
                                        </span>
                                      </p>

                                      <p class="mb-2 mx-1 email">
                                        <i class="bi bi-envelope-open  me-2"></i>

                                        <span>
                                          <a
                                            href={`mailto:${this.context.storeSettings.storeEmailId}`}
                                          >
                                            {" "}
                                            {
                                              this.context.storeSettings
                                                .storeEmailId
                                            }
                                          </a>
                                        </span>
                                      </p>

                                      <p class="mb-0 mx-1">
                                        <i class="bi bi-telephone  me-2"></i>
                                        <a
                                          href={`tel:+${this.context.storeSettings.defaultCountryCode}-${this.context.storeSettings.storePhoneNo}`}
                                        >
                                          +
                                          {
                                            this.context.storeSettings
                                              .defaultCountryCode
                                          }
                                          -
                                          {
                                            this.context.storeSettings
                                              .storePhoneNo
                                          }
                                        </a>
                                      </p>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                              <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                                Quick Links
                              </h5>
                              <div class="d-flex flex-column navFooter justify-content-start">
                                <a class=" mb-3 mx-1" href="/Home">
                                  <i class="bi bi-arrow-right  me-2"></i>Home
                                </a>
                                {/* <Link class="mb-3 mx-1" to="/Checkout">
                                  <i class="bi bi-arrow-right  me-2"></i>
                                  Checkout
                                </Link> */}
                                {this.context.userData.loginStatus ==
                                "active" ? (
                                  <>
                                    <Link class="mb-3 mx-1" to="/Checkout">
                                      <i class="bi bi-arrow-right  me-2"></i>
                                      Checkout
                                    </Link>
                                  </>
                                ) : (
                                  <>
                                    <a
                                      class="mb-3 mx-1"
                                      to="/Checkout"
                                      disabled
                                    >
                                      <i class="bi bi-arrow-right  me-2"></i>
                                      Checkout
                                    </a>
                                  </>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                              <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                                Popular Links
                              </h5>
                              <div class="d-flex flex-column navFooter justify-content-start">
                                <Nav.Link
                                  as={Link}
                                  to="/TermsAndConditions"
                                  className=""
                                >
                                  <i class="bi bi-arrow-right  me-2"></i>
                                  Terms & Conditions
                                </Nav.Link>
                                <Nav.Link
                                  as={Link}
                                  to="/PrivacyPolicy"
                                  className=""
                                >
                                  <i class="bi bi-arrow-right  me-2"></i>
                                  Privacy Policy
                                </Nav.Link>
                              </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                              <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                                Newsletter
                              </h5>
                              <form action="" className="newsLetter">
                                <div class="input-group">
                                  <input
                                    type="text"
                                    class="form-control p-3 text-white"
                                    placeholder="Your Email"
                                    name="signUpEmailId"
                                    value={this.state.signUpEmailId}
                                    onChange={(e) => this.onInputChange(e)}
                                  />
                                  <Button
                                    className="btn-green-2 d-inline-block text-white"
                                    onClick={(e) =>
                                      this.OnClickSignUpGreenNewsletters(e)
                                    }
                                  >
                                    Sign Up
                                  </Button>
                                </div>
                              </form>
                              {/* <h6 class="text-uppercase mt-4 mb-3">Follow Us</h6> */}
                              <div class="d-flex smIconFooter">
                                <a
                                  href={this.context.storeSettings.linkedinUrl}
                                  target="_blank"
                                  className="me-2"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="29"
                                    height="28"
                                    viewBox="0 0 29 28"
                                    fill="none"
                                  >
                                    <path
                                      d="M23.2985 2.24219H5.37818C3.83255 2.24219 2.57812 3.49659 2.57812 5.04219V22.9622C2.57812 24.5078 3.83255 25.7622 5.37818 25.7622H23.2985C24.8442 25.7622 26.0986 24.5078 26.0986 22.9622V5.04219C26.0986 3.49659 24.8442 2.24219 23.2985 2.24219ZM9.85827 11.2022V21.8422H6.4982V11.2022H9.85827ZM6.4982 8.10539C6.4982 7.32139 7.17021 6.72219 8.17823 6.72219C9.18625 6.72219 9.81907 7.32139 9.85827 8.10539C9.85827 8.88939 9.23105 9.52219 8.17823 9.52219C7.17021 9.52219 6.4982 8.88939 6.4982 8.10539ZM22.1785 21.8422H18.8184C18.8184 21.8422 18.8184 16.6566 18.8184 16.2422C18.8184 15.1222 18.2584 14.0022 16.8584 13.9798H16.8136C15.4584 13.9798 14.8984 15.1334 14.8984 16.2422C14.8984 16.7518 14.8984 21.8422 14.8984 21.8422H11.5383V11.2022H14.8984V12.6358C14.8984 12.6358 15.9792 11.2022 18.152 11.2022C20.3753 11.2022 22.1785 12.731 22.1785 15.8278V21.8422Z"
                                      fill="white"
                                      fill-opacity="0.6"
                                    ></path>
                                  </svg>
                                </a>
                                <a
                                  href={this.context.storeSettings.facebookUrl}
                                  target="_blank"
                                  className="me-2"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                  >
                                    <path
                                      d="M22.9626 2.24219H5.04224C3.49661 2.24219 2.24219 3.49659 2.24219 5.04219V22.9622C2.24219 24.5078 3.49661 25.7622 5.04224 25.7622H22.9626C24.5082 25.7622 25.7626 24.5078 25.7626 22.9622V5.04219C25.7626 3.49659 24.5082 2.24219 22.9626 2.24219ZM20.7225 10.6422H19.6025C18.4041 10.6422 17.9225 10.9222 17.9225 11.7622V13.4422H20.7225L20.1625 16.2422H17.9225V24.6422H15.1224V16.2422H12.8824V13.4422H15.1224V11.7622C15.1224 9.52219 16.2425 7.84219 18.4825 7.84219C20.1065 7.84219 20.7225 8.40219 20.7225 8.40219V10.6422Z"
                                      fill="white"
                                      fill-opacity="0.6"
                                    ></path>
                                  </svg>
                                </a>
                                <a
                                  href={this.context.storeSettings.twitterUrl}
                                  target="_blank"
                                  className="me-2"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                  >
                                    <path
                                      d="M22.9642 2.24219H5.04389C3.49826 2.24219 2.24384 3.49659 2.24384 5.04219V22.9622C2.24384 24.5078 3.49826 25.7622 5.04389 25.7622H22.9642C24.5099 25.7622 25.7643 24.5078 25.7643 22.9622V5.04219C25.7643 3.49659 24.5099 2.24219 22.9642 2.24219Z"
                                      fill="white"
                                      fill-opacity="0.5"
                                    ></path>
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M6.04815 6.0632C6.07265 6.09797 6.21455 6.30255 6.36346 6.51784C6.63881 6.91593 7.86335 8.6857 9.03817 10.3835C9.39516 10.8994 10.0383 11.8288 10.4673 12.4488C10.8963 13.0688 11.45 13.8687 11.6976 14.2263C11.9453 14.584 12.1498 14.8811 12.1521 14.8866C12.1572 14.8992 12.1716 14.8819 11.8215 15.2855C11.3874 15.7858 11.2375 15.9587 11.0094 16.2222C10.8169 16.4445 10.6702 16.6138 10.3769 16.9521C10.3089 17.0306 10.1722 17.1884 10.0732 17.3028C9.97418 17.4171 9.84854 17.5621 9.794 17.6249C9.73945 17.6877 9.61384 17.8326 9.51485 17.947C9.28893 18.208 9.01877 18.52 8.85797 18.7054C8.78991 18.7839 8.6532 18.9417 8.55417 19.0561C8.45514 19.1704 8.31835 19.3282 8.2502 19.4067C8.18203 19.4852 8.03256 19.6577 7.91803 19.79C7.8035 19.9223 7.61291 20.1425 7.49449 20.2793C7.37607 20.4161 7.20602 20.6124 7.1166 20.7156C7.02717 20.8188 6.8634 21.0077 6.75266 21.1356C6.64192 21.2634 6.48296 21.4469 6.39942 21.5433C6.31587 21.6398 6.20156 21.7719 6.14536 21.8369C6.08917 21.9019 6.03385 21.9652 6.02242 21.9776L6.00165 22L6.69905 21.9995L7.39645 21.9991L7.77414 21.5619C7.98188 21.3215 8.33661 20.9116 8.56245 20.6511C9.01993 20.1233 9.46624 19.6082 9.78119 19.2443C10.1724 18.7925 10.3925 18.5384 10.4919 18.4241C10.5465 18.3613 10.6832 18.2035 10.7957 18.0734C10.9082 17.9433 11.056 17.7727 11.1241 17.6942C11.1922 17.6157 11.3289 17.4579 11.4279 17.3435C11.527 17.2292 11.6637 17.0714 11.7318 16.9929C11.7998 16.9144 11.9461 16.7456 12.0569 16.6177C12.1676 16.4899 12.3313 16.3009 12.4208 16.1978C12.5102 16.0946 12.6245 15.9618 12.6748 15.9027C12.7251 15.8436 12.77 15.795 12.7745 15.7948C12.779 15.7945 12.9864 16.0888 13.2353 16.4486C13.4842 16.8085 14.1919 17.8314 14.808 18.7217C15.4241 19.612 16.1865 20.7139 16.5023 21.1702L17.0764 22H19.4224C21.0154 22 21.7701 21.9973 21.7737 21.9916C21.7765 21.987 21.7752 21.9843 21.7707 21.9855C21.762 21.9879 21.7267 21.9374 20.746 20.5199C20.3891 20.0041 19.5436 18.7821 18.867 17.8043C18.1904 16.8265 17.4667 15.7806 17.2588 15.4801C17.0509 15.1796 16.5467 14.4512 16.1384 13.8614C15.7301 13.2716 15.3944 12.7851 15.3926 12.7804C15.3895 12.7728 15.5065 12.6358 16.1375 11.9076C16.2305 11.8003 16.4003 11.6043 16.5148 11.472C16.6293 11.3397 16.7915 11.1525 16.8751 11.0561C17.1889 10.6942 17.2799 10.5893 17.476 10.3629C17.5867 10.2351 17.7472 10.0497 17.8328 9.95096C17.9184 9.85223 18.0868 9.65774 18.2071 9.51875C18.4784 9.20534 18.7945 8.84041 19.0264 8.57288C19.1236 8.46075 19.2714 8.29011 19.3549 8.19368C19.5162 8.00736 19.7977 7.6825 20.065 7.37411C20.1544 7.27095 20.3149 7.08563 20.4217 6.96228C20.5284 6.83894 20.7414 6.59304 20.895 6.41584C21.0485 6.23863 21.1921 6.07257 21.2141 6.04683L21.2541 6H20.5599H19.8656L19.7402 6.14475C19.6712 6.22437 19.5589 6.35372 19.4908 6.43221C19.4226 6.5107 18.9775 7.02446 18.5015 7.5739C18.0256 8.12334 17.5583 8.66279 17.463 8.77268C17.1979 9.07847 17.0541 9.24441 16.8308 9.50255C16.7182 9.63262 16.5814 9.79042 16.5269 9.85321C16.4723 9.916 16.3356 10.0738 16.223 10.2039C16.1105 10.3339 15.9627 10.5046 15.8946 10.5831C15.8265 10.6616 15.6802 10.8304 15.5695 10.9582C15.4588 11.086 15.2982 11.2714 15.2127 11.3701C15.1271 11.4688 14.9927 11.624 14.9141 11.7149C14.8354 11.8058 14.7683 11.8773 14.7648 11.8738C14.7614 11.8703 14.5124 11.5115 14.2115 11.0765C13.9105 10.6414 13.6236 10.2267 13.5739 10.1549C13.5241 10.0832 13.2759 9.72449 13.0222 9.35787C12.7686 8.99124 12.142 8.08573 11.6299 7.34564L10.6987 6H8.35116H6.00359L6.04815 6.0632ZM7.90159 7.04176C7.90169 7.04515 7.93422 7.09378 7.97389 7.14985C8.01355 7.20591 8.20999 7.48481 8.41041 7.76962C8.74711 8.24809 9.31299 9.05187 10.262 10.3996C10.4704 10.6956 10.774 11.1268 10.9366 11.3578C11.0992 11.5888 11.4312 12.0603 11.6743 12.4057C12.5355 13.6289 13.2054 14.5805 13.8214 15.4557C13.9193 15.5947 14.3004 16.136 14.6684 16.6585C15.0363 17.181 15.4459 17.7627 15.5785 17.9511C15.711 18.1394 16.0727 18.6532 16.3822 19.0928C16.6916 19.5323 17.1049 20.1195 17.3006 20.3976C17.4963 20.6756 17.6729 20.9261 17.693 20.9541L17.7296 21.0051H18.7975H19.8654L19.8291 20.9541C19.8091 20.9261 19.6082 20.6408 19.3826 20.3201C19.157 19.9994 18.736 19.4012 18.447 18.9908C18.158 18.5804 17.7885 18.0557 17.6259 17.8247C17.1958 17.2138 16.6613 16.4544 16.3228 15.9735C16.1602 15.7425 15.8037 15.2361 15.5305 14.8481C14.6545 13.6042 14.2248 12.9939 13.9515 12.6055C13.6395 12.1622 13.0156 11.2759 12.4789 10.5138C12.0532 9.90919 11.4596 9.0659 10.7108 8.00204C10.433 7.60734 10.1665 7.22936 10.1186 7.16208L10.0314 7.03976L8.96641 7.03768C8.38066 7.03655 7.90149 7.03839 7.90159 7.04176Z"
                                      fill="black"
                                    ></path>
                                  </svg>
                                </a>
                                <a
                                  href={this.context.storeSettings.instagramUrl}
                                  target="_blank"
                                  className="me-2"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="29"
                                    height="28"
                                    viewBox="0 0 29 28"
                                    fill="none"
                                  >
                                    <path
                                      d="M8.9319 2.24219C5.32412 2.24219 2.39844 5.16781 2.39844 8.77552V19.2289C2.39844 22.8366 5.32412 25.7622 8.9319 25.7622H19.3854C22.9932 25.7622 25.9189 22.8366 25.9189 19.2289V8.77552C25.9189 5.16781 22.9932 2.24219 19.3854 2.24219H8.9319ZM21.9988 4.85552C22.7201 4.85552 23.3055 5.44091 23.3055 6.16219C23.3055 6.88347 22.7201 7.46885 21.9988 7.46885C21.2775 7.46885 20.6921 6.88347 20.6921 6.16219C20.6921 5.44091 21.2775 4.85552 21.9988 4.85552ZM14.1587 7.46885C17.7664 7.46885 20.6921 10.3945 20.6921 14.0022C20.6921 17.6099 17.7664 20.5355 14.1587 20.5355C10.5509 20.5355 7.62521 17.6099 7.62521 14.0022C7.62521 10.3945 10.5509 7.46885 14.1587 7.46885ZM14.1587 10.0822C13.119 10.0822 12.1219 10.4952 11.3868 11.2303C10.6516 11.9655 10.2386 12.9625 10.2386 14.0022C10.2386 15.0418 10.6516 16.0389 11.3868 16.774C12.1219 17.5092 13.119 17.9222 14.1587 17.9222C15.1983 17.9222 16.1954 17.5092 16.9306 16.774C17.6657 16.0389 18.0787 15.0418 18.0787 14.0022C18.0787 12.9625 17.6657 11.9655 16.9306 11.2303C16.1954 10.4952 15.1983 10.0822 14.1587 10.0822Z"
                                      fill="white"
                                      fill-opacity="0.6"
                                    ></path>
                                  </svg>
                                </a>
                                <a
                                  href="https://www.youtube.com/@greenlimited4405"
                                  target="_blank"
                                  className="me-2"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="29"
                                    height="28"
                                    viewBox="0 0 29 28"
                                    fill="none"
                                  >
                                    <path
                                      d="M25.028 8.03253C24.8106 6.83245 23.7746 5.95849 22.5723 5.68565C20.7732 5.30409 17.4436 5.03125 13.8412 5.03125C10.2408 5.03125 6.85792 5.30409 5.05669 5.68565C3.85658 5.95849 2.81847 6.77702 2.60105 8.03253C2.38149 9.39675 2.16406 11.3067 2.16406 13.7623C2.16406 16.2178 2.38149 18.1278 2.65434 19.492C2.8739 20.6921 3.90987 21.566 5.10998 21.8389C7.01993 22.2204 10.2941 22.4933 13.8966 22.4933C17.499 22.4933 20.7732 22.2204 22.6832 21.8389C23.8833 21.566 24.9193 20.7475 25.1388 19.492C25.3562 18.1278 25.6291 16.1624 25.6845 13.7623C25.5737 11.3067 25.3008 9.39675 25.028 8.03253ZM10.8952 17.5821V9.94244L17.5523 13.7623L10.8952 17.5821Z"
                                      fill="white"
                                      fill-opacity="0.6"
                                    ></path>
                                  </svg>
                                </a>
                                <a
                                  href="https://vimeo.com/user154755399"
                                  target="_blank"
                                  className="me-2"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="27"
                                    height="28"
                                    viewBox="0 0 27 28"
                                    fill="none"
                                  >
                                    <path
                                      d="M22.9648 2.24219H5.04444C3.49881 2.24219 2.24438 3.49659 2.24438 5.04219V22.9622C2.24438 24.5078 3.49881 25.7622 5.04444 25.7622H22.9648C24.5104 25.7622 25.7648 24.5078 25.7648 22.9622V5.04219C25.7648 3.49659 24.5104 2.24219 22.9648 2.24219Z"
                                      fill="white"
                                      fill-opacity="0.5"
                                    ></path>
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M17.9208 8.06104C17.2265 8.20351 16.6871 8.48852 16.2026 8.96894C15.846 9.32251 15.6182 9.64446 15.3573 10.1635C15.1824 10.5116 14.9034 11.2125 14.9294 11.2385C14.9362 11.2453 15.0591 11.2112 15.2024 11.1626C15.5256 11.053 16.0538 11.013 16.2984 11.0794C16.5245 11.1409 16.739 11.3164 16.8174 11.5041C16.8934 11.6859 16.8932 12.2584 16.817 12.5406C16.7261 12.8772 16.5439 13.2809 16.2574 13.7804C15.5866 14.9497 14.9869 15.6509 14.6576 15.6509C14.4829 15.6509 14.3415 15.5161 14.1689 15.1851C13.8451 14.5643 13.6305 13.6855 13.2469 11.4096C12.9706 9.77061 12.9237 9.56833 12.7221 9.14612C12.5198 8.72247 12.2792 8.46334 11.9272 8.29007C11.6677 8.16227 11.5974 8.14709 11.2661 8.14722C10.9282 8.14731 10.8655 8.16162 10.5562 8.30917C10.1451 8.50536 9.71292 8.79977 9.21536 9.2225C8.49778 9.8322 7.0022 11.1828 7.0022 11.2212C7.0022 11.3103 7.62464 12.0445 7.68172 12.0226C7.71456 12.01 7.88343 11.9041 8.05695 11.7872C8.46872 11.5098 8.62541 11.4314 8.76753 11.4314C9.01091 11.4314 9.28692 11.6998 9.52356 12.1665C9.75242 12.6178 9.94917 13.2473 10.5463 15.4383C10.8943 16.7156 11.2304 17.8879 11.2931 18.0434C11.6301 18.8794 12.1567 19.5957 12.6194 19.8475C12.9188 20.0105 13.4053 20.0466 13.8317 19.9375C14.9369 19.6549 16.286 18.5451 17.774 16.6949C19.383 14.6941 20.4697 12.8233 20.8008 11.4845C20.9311 10.9577 20.9307 9.99616 20.8001 9.51065C20.5794 8.69054 20.1631 8.25506 19.4131 8.05974C19.1052 7.97952 18.3146 7.98022 17.9208 8.06104Z"
                                      fill="black"
                                    ></path>
                                  </svg>
                                </a>
                              </div>
                              <p class="copy-footer footer-end-media">
                                © {new Date().getFullYear()} GREEN. All Rights
                                Reserved.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <div className="text-black text-center">
                        <h5>
                          <b>
                            {window.location.hostname ==
                            "restaurant.elasticcart.com"
                              ? "Powered by SANTREZA IT Solutions Privated Limited, Bangalore, India 560100. Contact: +919663617620, +919880582728"
                              : ""}
                          </b>
                        </h5>
                      </div> */}
                    </div>
                  </>
                ) : (
                  <div
                    class="container-fluid homefooter mt-2 py-1"
                    style={{
                      backgroundColor:
                        window.location.hostname == "maicabagfactory.com" ||
                        window.location.hostname == "www.maicabagfactory.com"
                          ? "#00ff00"
                          : this.context.theme.mainNavBarBackgroundColor,
                      color: this.context.theme.mainNavBarTextColor,
                    }}
                  >
                    <div class="container pt-5">
                      <div class="row g-5">
                        <div class="col-lg-3 col-md-6">
                          <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                            Get In Touch
                          </h5>
                          <p class="mb-4"></p>
                          <p class="mb-2">
                            <i class="bi bi-geo-alt  me-2"></i>
                            {this.context.storeSettings.storeName},&nbsp;
                            {this.context.storeSettings.storeAddress}
                          </p>

                          <p class="mb-2">
                            <i class="bi bi-envelope-open  me-2"></i>

                            <a
                              href={`mailto:${this.context.storeSettings.storeEmailId}`}
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                            >
                              <u>{this.context.storeSettings.storeEmailId}</u>
                            </a>
                          </p>
                          <p class="mb-0">
                            <i class="bi bi-telephone  me-2"></i>
                            <a
                              href={`tel:+${this.context.storeSettings.defaultCountryCode}-${this.context.storeSettings.storePhoneNo}`}
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                            >
                              {"+" +
                                this.context.storeSettings.defaultCountryCode}
                              -{this.context.storeSettings.storePhoneNo}
                            </a>
                          </p>
                        </div>
                        <div class="col-lg-3 col-md-6">
                          <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                            Quick Links
                          </h5>
                          <div class="d-flex flex-column justify-content-start">
                            <a
                              class=" mb-3 mx-4"
                              href="/Home"
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                            >
                              <i class="bi bi-arrow-right  me-2"></i>Home
                            </a>
                            {this.context.storeSettings.isQuotationSupported !=
                            true ? (
                              <>
                                <Link
                                  class=" mb-3 mx-4"
                                  to="/Cart"
                                  style={{
                                    color:
                                      this.context.theme.mainNavBarTextColor,
                                  }}
                                >
                                  <i class="bi bi-arrow-right  me-2"></i>My Cart
                                </Link>
                              </>
                            ) : (
                              <></>
                            )}

                            {this.context.userData.loginStatus == "active" &&
                            this.context.storeSettings.isQuotationSupported !=
                              true ? (
                              <>
                                <Link
                                  class=" mb-3 mx-4"
                                  to="/Checkout"
                                  style={{
                                    color:
                                      this.context.theme.mainNavBarTextColor,
                                  }}
                                >
                                  <i class="bi bi-arrow-right  me-2"></i>
                                  Checkout
                                </Link>
                              </>
                            ) : (
                              <></>
                            )}

                            {window.location.hostname ==
                            "green.elasticcart.com" ? (
                              <></>
                            ) : (
                              <>
                                <Link
                                  class=" mb-3 mx-4"
                                  to="/VisitorsCount"
                                  style={{
                                    color:
                                      this.context.theme.mainNavBarTextColor,
                                  }}
                                >
                                  <i class="bi bi-arrow-right  me-2"></i>{" "}
                                  Visitors Count
                                </Link>
                              </>
                            )}
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                          <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                            Popular Links
                          </h5>
                          <div class="d-flex flex-column justify-content-start">
                            <Nav.Link
                              as={Link}
                              to="/TermsAndConditions"
                              className=""
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                            >
                              <i class="bi bi-arrow-right  me-2"></i>
                              <u>Terms & Conditions</u>
                            </Nav.Link>
                            <Nav.Link
                              as={Link}
                              to="/PrivacyPolicy"
                              className=""
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                            >
                              <i class="bi bi-arrow-right  me-2"></i>
                              <u>Privacy Policy</u>
                            </Nav.Link>

                            <Nav.Link
                              as={Link}
                              to="/ContactUs"
                              className=""
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                            >
                              <i class="bi bi-arrow-right  me-2"></i>
                              <u>Contact Us</u>
                            </Nav.Link>

                            <Nav.Link
                              as={Link}
                              to="/Faqs"
                              className=""
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                            >
                              <i class="bi bi-arrow-right  me-2"></i>
                              <u>FAQs</u>
                            </Nav.Link>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                          <h5 class="text-uppercase border-start border-5 border-primary ps-3 mb-4">
                            Newsletter
                          </h5>
                          <form action="">
                            <div class="input-group">
                              <input
                                type="text"
                                class="form-control p-3"
                                placeholder="Your Email"
                              />
                              {window.location.hostname ==
                              "green.elasticcart.com" ? (
                                <>
                                  <button className="btn-green-2 d-inline-block text-white">
                                    Sign Up
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button class="btn btn-primary">
                                    Sign Up
                                  </button>
                                </>
                              )}
                            </div>
                          </form>
                          <h6 class="text-uppercase mt-4 mb-3">Follow Us</h6>
                          <div class="d-flex">
                            <a
                              class="btn btn-outline-primary btn-square me-2"
                              href={this.context.storeSettings.twitterUrl}
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                              target="_blank"
                            >
                              <i class="bi bi-twitter"></i>
                            </a>
                            <a
                              class="btn btn-outline-primary btn-square me-2"
                              href={this.context.storeSettings.facebookUrl}
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                              target="_blank"
                            >
                              <i class="bi bi-facebook"></i>
                            </a>
                            <a
                              class="btn btn-outline-primary btn-square me-2"
                              href={this.context.storeSettings.linkedinUrl}
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                              target="_blank"
                            >
                              <i class="bi bi-linkedin"></i>
                            </a>
                            <a
                              class="btn btn-outline-primary btn-square"
                              href={this.context.storeSettings.instagramUrl}
                              style={{
                                color: this.context.theme.mainNavBarTextColor,
                              }}
                              target="_blank"
                            >
                              <i class="bi bi-instagram"></i>
                            </a>
                          </div>
                        </div>
                      </div>

                      <br />
                      <div
                        className="text-center py-5"
                        style={{
                          backgroundColor:
                            window.location.hostname == "maicabagfactory.com" ||
                            window.location.hostname ==
                              "www.maicabagfactory.com"
                              ? "#00ff00"
                              : this.context.theme.mainNavBarBackgroundColor,
                          color: this.context.theme.mainNavBarTextColor,
                        }}
                      >
                        <div classname="container-fluid mx-0 px-0 ">
                          <div>
                            <h6>
                              <b>
                                Copyright ©{" "}
                                {this.context.storeSettings.storeName}, All
                                Rights Reserved.
                              </b>
                            </h6>
                          </div>
                        </div>
                        <br />
                      </div>
                      {/* <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <div className="text-black text-center">
                        <div classname="container-fluid mx-0 px-0 bg-dark text-white">
                          <div class="bar">
                            <span class="">
                              Powered by{" "}
                              <a href="https://ElasticCart.com" target="_blank">
                                {" "}
                                www.ElasticCart.Com
                              </a>
                              , Bangalore, India 560100. Contact: +919663
                              617620, +919880 582728
                            </span>
                          </div>
                        </div>
                      </div>
                      <br />
                      <br /> */}
                      {/* <div className="text-black text-center py-3">
                        <div classname=" my-3 px-0 bg-dark text-white">
                          <div class="bar">
                            <span class="">
                              Powered by{" "}
                              <a href="https://ElasticCart.com" target="_blank">
                                {" "}
                                www.ElasticCart.Com
                              </a>
                            </span>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                )}
                <p className="p-3">
                  <h2>
                    {" "}
                    <b>Our Location Map</b>
                  </h2>
                  <iframe
                    className="border"
                    src={this.context.storeSettings.googlemapEmbedUrl}
                    width="100%"
                    height="450"
                    style={{ border: "1" }}
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </p>
              </>
            ) : (
              <></>
            )}
          </>
        )}
      </>
    );
  }
}

function LatAndLongi(props) {
  const [userAddress, setUserAddress] = useState(null);
  const [lat, setLat] = useState(null);
  const [longi, setLongi] = useState(null);
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      function () {},
      function () {},
      {}
    );
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        console.log("Latitude is :", position.coords.latitude);
        console.log("Longitude is :", position.coords.longitude);
        setLat(position.coords.latitude);
        setLat(position.coords.longitude);
        props.latlong(position.coords.latitude, position.coords.longitude);
      },
      function (e) {
        //Your error handling here
      },
      {
        maximumAge: 60000,
        timeout: 2000,
        enableHighAccuracy: true,
      }
    );
  }, []);
  return (
    <div>
      User's address:latitude {lat} longitude {longi}
    </div>
  );
}
